<template>
  <Modal v-model="model" :title="title" sticky reset-drag-position @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="trigger-pop-style" width="800">
  <font style="font-size:10px;color:gray">SLA由响应时长和处理时长两个指标组成。从工单创建时间点开始计时，到达第一个公开回复时间点为响应时长，到达最后一个处理完毕时间点为处理时长。
  中间剔除暂停的时间。</font>
    <div class="input_single">
      <div class="font_style_set"><span style="color: #ed4014">*</span>SLA规则名称:</div>
      <Input v-model="slaName" class="input_content"  placeholder="请输入名称"/>
    </div>
    <div class="input_single">
      <div class="font_style_set"><span style="color: #ed4014">*</span>工单类型:</div>
      <Select v-model="orderType" class="input_content" placeholder="请选择工单类型" multiple clearable :disabled="orderType == '0'">
          <Option v-for="item in orderTypeList" :value="item.id" :key="item.id">{{item.dictValue}}</Option>
      </Select>
    </div>
    <div class="input_single">
      <div class="font_style_set">备注:</div>
      <Input v-model="slaDescr" class="input_content" type="textarea"  placeholder="请输入备注"/>
    </div>

      <Table :columns="tableColumns" :data="contentList">
        <template slot-scope="{ row }" slot="icon">
           <Icon type="md-alarm" color="#71B1F3" :size="24"/>
        </template>
        <template slot-scope="{ row, index }" slot="responseTime" >
          <div class="contain-style">
            <Input class="duration-style" v-model="row.responseTime.hour" :number="true" @on-blur="dataChange(index,row)"> <span slot="append" >时</span> </Input>
            <Input class="duration-style" v-model="row.responseTime.min" :number="true" @on-blur="dataChange(index,row)"> <span slot="append">分</span> </Input></div>
        </template>
        <template slot-scope="{ row, index }" slot="processingTime">
           <div class="contain-style">
            <Input class="duration-style" v-model="row.processingTime.day" :number="true" @on-blur="dataChange(index,row)"> <span slot="append" >天</span> </Input>
            <Input class="duration-style" v-model="row.processingTime.hour" :number="true" @on-blur="dataChange(index,row)"> <span slot="append" >时</span> </Input>
            <Input class="duration-style" v-model="row.processingTime.min" :number="true" @on-blur="dataChange(index,row)"> <span slot="append">分</span> </Input></div>
        </template>
    </Table>

    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" :loading="loading" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
    export default {
      name: "SlaPagePop",
      props:{
          showPop:Boolean,
          slaId:String
      },
      data(){
        return{
          model:false,
          title:"",
          slaName:'',
          slaDescr:'',
          orderType:'',
          id:'',
          menuId:'3_d-4-1',
          tableColumns:[{ title: ' ', slot: 'icon' ,width: 70, align: 'center'}, { title: '优先级', key: 'dictValue',width: 100, align: 'center' },
                        { title: '响应时长', slot: 'responseTime', align: 'center' }, { title: '处理时长', slot: 'processingTime', align: 'center' } ],
          contentList:[],
          orderTypeList:[],
          loading: false,
        }
      },
      methods:{
        cancel:function () {
          this.slaName = "";
          this.slaDescr = "";
          this.orderType = '';
          this.$emit("closeSlaPop",false)
        },

        init:function(){
          let param = {
            id : this.id,
            journalType:"null",
            menuId:"null"
          }
          let that = this;
          this.$http.post("sla/toIndex.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$Message.error(res.data.msg);
                  return false;
                }
                that.contentList = res.data.obj.list.content;
                that.orderTypeList = res.data.obj.orderType;
                that.slaName = res.data.obj.slaName;
                that.slaDescr = res.data.obj.slaDescr;
                that.orderType = res.data.obj.orderTypeValue;
              })
        },
        save:function () {
          let that=this;
          if (!this.slaName){
            this.$Message.info("SLA规则名称不能为空");
            return false;
          }
          if (!this.orderType || this.orderType.length <= 0){
            this.$Message.info("工单类型不能为空");
            return false;
          }
          this.loading = true;
          let reg=/^[0-9]*$/;
          for(let i = 0; i < this.contentList.length; i++){
            this.contentList[i].processingTime.day = this.contentList[i].processingTime.day ? this.contentList[i].processingTime.day : 0;
            this.contentList[i].processingTime.hour = this.contentList[i].processingTime.hour ? this.contentList[i].processingTime.hour : 0;
            this.contentList[i].processingTime.min = this.contentList[i].processingTime.min ? this.contentList[i].processingTime.min : 0;
            this.contentList[i].responseTime.hour = this.contentList[i].responseTime.hour ? this.contentList[i].responseTime.hour : 0;
            this.contentList[i].responseTime.min = this.contentList[i].responseTime.min ? this.contentList[i].responseTime.min : 0;
            // 判断格式
            if(!reg.test(this.contentList[i].responseTime.hour) || !reg.test(this.contentList[i].responseTime.min)){
               this.$Message.info(this.contentList[i].dictValue+"对应的响应时长仅支持数字且大于0");
               this.loading = false;
              return false;
            }
            if(!reg.test(this.contentList[i].processingTime.day) || !reg.test(this.contentList[i].processingTime.hour) || !reg.test(this.contentList[i].processingTime.min)){
               this.$Message.info(this.contentList[i].dictValue+"对应的处理时长仅支持数字且大于0");
               this.loading = false;
              return false;
            }

            if(this.contentList[i].responseTime.hour == 0 && this.contentList[i].responseTime.min == 0){
              this.$Message.info(this.contentList[i].dictValue+"对应的响应时长必须大于0");
              this.loading = false;
              return false;
            }
            // 将响应时长计算为总分钟数
            this.contentList[i]["responseMin"] = (parseInt(this.contentList[i].responseTime.hour) * 60) + parseInt(this.contentList[i].responseTime.min);


            if(this.contentList[i].processingTime.day == 0 && this.contentList[i].processingTime.hour == 0 && this.contentList[i].processingTime.min == 0){
              this.$Message.info(this.contentList[i].dictValue+"对应的处理时长必须大于0");
              this.loading = false;
              return false;
            }
            // 将响应时长计算为总分钟数
            this.contentList[i]["processingMin"] = parseInt(this.contentList[i].processingTime.day) * 60 * 24 + parseInt(this.contentList[i].processingTime.hour) * 60 + parseInt(this.contentList[i].processingTime.min);
          }
          let param={
            id: this.id,
            slaName:this.slaName,
            slaDescr:this.slaDescr ? this.slaDescr : '',
            orderType: this.orderType.length > 0 ? this.orderType : "",
            contentList: JSON.stringify(this.contentList),
            journalType:"系统管理=>工单配置=>"+this.title,
            menuId:this.menuId
          };
          this.$http.post("sla/doSave.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Message.error(res.data.msg);
              that.loading = false;
              return false;
            }
            that.$Message.success("操作成功");
            that.slaName = "";
            that.slaDescr = "";
            that.orderType = '';
            that.loading = false;
            that.$emit("closeSlaPop",true);
          })
        },
        dataChange:function(index,val){
          this.contentList[index] = val;
        }
      },
      created(){

      },
      watch:{
          showPop:function() {
            this.model=this.showPop;
          },
          slaId:function(){
            if(this.slaId){
              this.id = this.slaId;
              if(this.id != '-1'){
                this.title = "编辑SLA";
              }else{
                this.title = "添加SLA";
              }
              this.init();
            }
          }

        }
    }
</script>

<style scoped>
.contain-style{
    display:flex;
    height: 35px;
    align-items: center;
    justify-content: center;
}
.duration-style{
  width:30%;
  margin-right:3%
}
.input_single{
  margin-top:10px;
  margin-left:10px;
  margin-right:10px;
  display:flex;
}
.input_single .input_content{
  width: 93%;
  margin-left:10px;
}
.font_style_set{
    width: 15%;
    text-align: end;
}

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/worknote/SlaPagePop.vue